export const LocalStorage = {
  Organizations: {
    LastVisited: 'last-visited-organization',
  },
}
